export default __webpack_public_path__ + "static/media/1-como-funciona.a9b1ef25.png";